import { Stack, Typography } from '@mui/material';
import {
  InformationCircle,
  SurchargeCalendarIcon,
  SurchargeMoonIcon,
  SurchargeProfileIcon,
  SurchargeTreeIcon,
} from 'assets';
import { EmptyUI, PackageCreditItem } from 'components';
import { ENUM_ORDER_SORT } from 'models';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { getPackageListAction } from 'store/reducers/credits/actionTypes';
import { theme } from 'theme';

const surcharges = [
  {
    icon: <SurchargeMoonIcon />,
    title: 'Before 8am & after 6pm',
    subTitle: 'Applied to Weekdays and Weekends',
    price: 2,
  },
  {
    icon: <SurchargeCalendarIcon />,
    title: 'Weekend',
    subTitle: 'Applies to all hours on the Weekend',
    price: 2,
  },
  {
    icon: <SurchargeTreeIcon />,
    title: 'Public Holidays',
    subTitle: 'Applied to all Singapore public holidays',
    price: 5,
  },
  {
    icon: <SurchargeProfileIcon />,
    title: 'Additional Child',
    subTitle: 'Applies to families with > 1 kid',
    price: 5,
  },
];

export const BuyCredits = () => {
  const dispatch = useAppDispatch();
  const { packageList } = useAppSelector((state) => state.credits);

  useEffect(() => {
    dispatch(
      getPackageListAction({
        data: { sort: `price-${ENUM_ORDER_SORT.ASC}` },
      }),
    );
  }, [dispatch]);

  return (
    <Stack alignItems="center">
      <Stack spacing={1} alignItems="center">
        <Typography variant="Web_Title_22">Buy Credits</Typography>
        <Typography variant="Web_Label_18">
          Select a Sitter Plan to purchase
        </Typography>
      </Stack>
      <Stack
        direction="row"
        spacing={1}
        maxWidth="840px"
        bgcolor={theme.palette.primary_shades[8]}
        sx={{
          borderRadius: 2,
          margin: { xs: '10px', md: '0px' },
          marginTop: '22px',
          padding: '10px',
        }}
      >
        <InformationCircle />
        <Typography variant="Web_Label_14">
          Please note the following: Actual price may vary according to
          additional surcharges due to your request. Packages are valid for 6
          months from the date of purchase, please use up any existing credits
          before purchasing a new package.
        </Typography>
      </Stack>
      <Stack alignItems={'center'} justifyContent={'center'} spacing={2} mt={4}>
        <Typography variant="Web_Title_22">Packages</Typography>
        <Stack
          flexDirection="row"
          alignItems="center"
          justifyContent="center"
          flexWrap="wrap"
          sx={{ gap: 1 }}
        >
          {packageList.length > 0 ? (
            packageList.map((item) => (
              <PackageCreditItem key={item.id} data={item} />
            ))
          ) : (
            <EmptyUI content="There are no packages available" />
          )}
        </Stack>
      </Stack>

      <Stack
        alignItems={'center'}
        justifyContent={'center'}
        spacing={2}
        mt={10}
      >
        <Typography variant="Web_Title_22">Surcharges</Typography>
        <Stack
          direction={'row'}
          alignItems={'center'}
          justifyContent={'center'}
          flexWrap={'wrap'}
          gap={1}
        >
          {surcharges.map((item, index) => (
            <Stack
              key={index}
              spacing={1.5}
              sx={{
                borderRadius: '24px',
                border: '1px solid #00000014',
                p: 2,
                width: '205px',
                height: '180px',
              }}
            >
              {item.icon}
              <Stack>
                <Typography fontSize={14} fontWeight={600} color={'#545454'}>
                  {item.title}
                </Typography>
                <Typography fontSize={12} color={'#959595'}>
                  {item.subTitle}
                </Typography>
              </Stack>
              <Typography fontSize={14} fontWeight={600} color={'#000000'}>
                ${item.price}/hr
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default BuyCredits;
